import { resources } from "@constants/hardcoded-strings";
import {
    ServicesServiceOfferingValidationErrors,
    ServicesValidationErrors,
} from "@idw-types/common/validation/verification-service-details-validation-errors/verification-service-details-validation-errors";
import { FormattedRpServiceConfigurationAttribute, FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";

export const getServicesValidationErrors = (
    activeServices: Array<FormattedRpServiceConfigurationServiceOffering>,
    activeAttributes: Array<FormattedRpServiceConfigurationAttribute>
): ServicesValidationErrors => {

    const humanIdentityValidationErrors = getServicesServiceOfferingValidationErrors(
        resources.pages.verificationServiceDetails.tabs.services.subTabs.humanIdentity.tabName,
        activeServices,
        activeAttributes
    );
    const relationshipsValidationErrors = getServicesServiceOfferingValidationErrors(
        resources.pages.verificationServiceDetails.tabs.services.subTabs.relationships.tabName,
        activeServices,
        activeAttributes
    );
    const environmentalValidationErrors = getServicesServiceOfferingValidationErrors(
        resources.pages.verificationServiceDetails.tabs.services.subTabs.environmental.tabName,
        activeServices,
        activeAttributes
    );

    const count = humanIdentityValidationErrors.count + relationshipsValidationErrors.count + environmentalValidationErrors.count;

    return {
        humanIdentity: humanIdentityValidationErrors,
        relationships: relationshipsValidationErrors,
        environmental: environmentalValidationErrors,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.services.tabName} errorCount={count} />
    };
};

const getServicesServiceOfferingValidationErrors = (
    tabName: string,
    activeServices: Array<FormattedRpServiceConfigurationServiceOffering>,
    activeAttributes: Array<FormattedRpServiceConfigurationAttribute>
): ServicesServiceOfferingValidationErrors => {
    let count = 0;
    let servicesError = null;
    if (activeServices.length === 0 && activeAttributes.length === 0) {
        count += 1;
        servicesError = (
            <ErrorAlert>
                <div>
                    <span>In order to minimally configure this verification service, add <b>at least one</b> of <b>either</b>:</span>
                    <ul>
                        <li>A service in this category</li>
                        <li>Or, an attribute under the Attributes section</li>
                    </ul>
                </div>
            </ErrorAlert>
        );
    }

    return {
        servicesError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={tabName} errorCount={count} />
    };
};
